// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Ibpt","content":"styles_content__2ykdH","selectAll":"styles_selectAll___9zyV"};